/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {useCallback} from 'react';
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site';

import {resolveBrowserGeoCountryCode} from '@amblique/king-living/app/utils/browser-geo-address';
import {useGeocoding} from './use-geocoding';

/**
 * Resolves shopper country via client-side Google Geolocation + server reverse geocode.
 *
 * @returns {{ resolveBrowserGeoCountry: (apiKey: string) => Promise<string|null> }}
 */
export function useBrowserGeoCountry() {
  const {site} = useMultiSite();
  const siteId = site?.id;
  const {reverseGeocode} = useGeocoding();

  const resolveBrowserGeoCountry = useCallback(
    async (apiKey) => {
      return resolveBrowserGeoCountryCode({siteId, apiKey, reverseGeocode});
    },
    [reverseGeocode, siteId]
  );

  return {resolveBrowserGeoCountry};
}
